
<template>
  <div class="reloader" v-if="dfdisOpen?true:false">
    <div 
      :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
      :class="['dots', { 'dots--active': active }]"
      aria-hidden="true">
      <span class="dot" />
      <span class="dot" />
      <span class="dot" />
    </div>

</div></template>

<script>

// Dfd redirection

const params = new URLSearchParams(window.location.search);
const cwAuthToken = params.get('cw_auth_token');
localStorage.setItem('cwbAuthToken', cwAuthToken);



import axios from 'axios';
import config from 'config';
import { mapGetters } from 'vuex';
import DOMPurify from 'dompurify';

export default {

  
  // Props
  props: {
    active: Boolean,
  },


  data() {
    return {
      dfdisOpen: true, 
      showDfdPopup : true,

      dfd_md_live:'',

    };
  },


  computed: {
    ...mapGetters('app', ['org']),
  },

  methods: {

    getUserDetails() {
      const cwbAuthToken = localStorage.getItem('cwbAuthToken');
      const apiurl = config.api;
      axios.defaults.headers.common.Authorization = `${cwbAuthToken}`;
      const date = new Date();
      const timestamp = date.toISOString();


      axios.get( `${apiurl}v2/userdetails`)
        .then(response => {
          if(response.status === 200){
            localStorage.setItem('updateUser', JSON.stringify(response.data));
            localStorage.setItem('fueledAuthToken', response.data.auth_token);
            sessionStorage.setItem('fueledAuthTokenTimestamp', timestamp);
            localStorage.setItem('mdLiveAuthToken', response.data.md_live.jwt);
            sessionStorage.setItem('mdLiveAuthTokenTimestamp', timestamp);


            const baseUrl = config.mdLiveApi;
            const storedUser = JSON.parse(localStorage.getItem('updateUser'));
            const model = {
              id: storedUser.mdlive_id,
              token: storedUser.md_live.jwt,
            };

            axios.get( `${baseUrl}/v2/patients/${model.id}/appointments/upcoming`,{
              headers: {
                Authorization: `Bearer ${model.token}`,
              },
        
            })
              .then(response => {
                if(response.status === 200 && response.data.appointments.length>=1){
                  this.$router.push ({ name: 'home' }); 
                } else{
                  this.$router.push ({ name: 'results' }); 
                }
              });
          }
        })
        

        .catch(error =>  {
          const id = window.location.pathname.split('/')[1];
          axios.get(`${apiurl}organisations/v2/configuration?domain=${id}`)
            .then(response => {
              const dfdOrg = response.data.dfd_redirect_url;
              const sanitizedDfdOrg = DOMPurify.sanitize(dfdOrg, { ALLOWED_URI_REGEXP: /^(?:(?:https?|mailto):|[^a-z]|[a-z+.\\-]+(?:[^a-z+.\-:]|$))/i });
              console.log('token expired', error);
              window.location.href = `${sanitizedDfdOrg}/sign-in?cw=true`;
            });
        });
      


    },

  },


  created() {
    this.getUserDetails();
  },

};

</script>
<style scoped>

.reloader{
  text-align: center;
  margin-top: 12.7%;
  min-height: 35%;
}

.dfdpopup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.dfdpopup-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.dfdpopup-content {
  background-color: white;
  padding: 1rem;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  z-index: 9;
}

</style>



// WEBPACK FOOTER //
// Dfd.vue?4f82df9a